import { PropertyPhotoGrid } from "@/components/shared";

interface PropDetailsMediaProps {
  allImages: string[];
}

const PropDetailsMedia = ({ allImages }: PropDetailsMediaProps) => {
  if (!allImages?.length) return null;
  return <PropertyPhotoGrid allImages={allImages} />;
};

export default PropDetailsMedia;
